<template>
  <div class="outro-stage light-curved-bg inert-while-dialog-open">
    <div class="countdown-container">
      <div class="label">Noch</div>
      <Countdown :countdown-date="nextSylvester" />
      <div class="label">bis Neujahr!</div>
    </div>

    <h3
      :class="{ alone: false }"
    >
      {{ $l("journeyHeadline") }}
    </h3>

    <div class="teaser-container">
      
      <!-- <a href="https://j89v.adj.st/coupons?adjust_t=96r0pnn&adjust_campaign=REWEBonus&adjust_adgroup=Onsite-REWEBonus-REWEBonus-KW01-2025&adjust_creative=Onsite-REWEBonus-REWEBonus-KW01-2025-REWE-Bonus-20%25-Feuerwerk&adjust_redirect_windows=https%3A%2F%2Frewe.de%2Fbonus&adjust_redirect_macos=https%3A%2F%2Frewe.de%2Fbonus&rt=1" 
        target="_blank" 
        class="col bonus" 
      >
        <div class="image"></div>
        <div class="content bonus-curved-bg">
          <div>
            <h4>Extra-Knaller: 20% Bonus auf Feuerwerk!*</h4>
            <p>
              REWE Bonus-Coupon aktivieren und 20% Bonus-Guthaben auf Feuerwerksartikel sichern! Nur in der REWE App!
            </p>
          </div>
          <button class="button-primary" aria-label="Jetzt Coupon aktivieren" tabindex="-1">
            Jetzt Coupon aktivieren
          </button>
        </div>
      </a> -->
      
      <a
        href="https://www.rewe.de/ernaehrung/silvester/?icid=rewe|ak|sale|n|Q4-25-Feuerwerksverkauf-2025-M_rewe-de:feuerwerk2025:start_int_content_rewe-de:ernaehrung:silvester_nn_nn_nn_nn"
        target="_blank"
        :class="{
          col: true,
          recipes: true,
          alone: false
        }"
      >
        <div class="image"></div>
        <div class="content dark-curved-bg">
          <div>
            <h4>{{ $l("teaserRdkHeadline") }}</h4>
            <p>
              {{ $l("teaserRdkCopy") }}
            </p>
          </div>
          <button class="button-primary" aria-label="Zu Rezepten und mehr" tabindex="-1">
            <i class="icon-kueche" aria-hidden="true"></i> Zu Rezepten und mehr
          </button>
        </div>
      </a>
      
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import Countdown from "@/components/CountdownTimer";
import config from "@/config";
export default {
  components: { Countdown },
  props: {
    
  },
  mounted(){
    if (!document.querySelector('#newsletter-overlay-loader')) {
      const script = document.createElement('script');

      script.setAttribute('id', 'newsletter-overlay-loader');
      script.setAttribute('src', 'https://www.rewe.de/api/newsletter-registration/overlay-loader.js');
      script.setAttribute('defer', 'defer');

      document.body.appendChild(script);
    }
  },
  methods: {
    openNl() {
      document.dispatchEvent(new CustomEvent('NewsletterOverlay:show', {
        detail: {
          touchpointId: 44,
          // tabIndex: 0,
          trackingId: 'Feuerwerk_2025',
          onError: () => { this.error = true; },
          baseUrl: 'https://www.rewe.de',
        },
      }));
    },
  },
  computed: {
    ...mapState([
      "dialogOpen"
    ]),
    nextSylvester() {
      return config.nextSylvester.format("YYYY-MM-DDTHH:mm:ss");
    },
    tvcUrl() {
      return this.$l("tvcUrl");
    },
    thisHideSpot() {
      if (this.hideSpot) {
        return true;
      } else {
        return !this.tvcUrl;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
@import "./HomeOutro";
</style>
